module.exports = __webpack_public_path__ + "static/media/face6.16be9a5e.jpg";